export default {
  id: 49,
  title: 'Target #49 - Stay at Home',
  url: 'https://cssbattle.dev/play/49',
  colors: ['#6592CF', '#243D83', '#EEB850'],
  solution:
    '<a a><a b><a c><a d><style>body{background:#6592CF}a{position:fixed}a[c],a[d]{background:#EEB850}a[a]{bottom:150;left:100;border:100px solid transparent;border-bottom:100px solid #243D83}a[b]{top:150;left:125;width:150;height:100;background:#243D83;border-radius:0 0 10px 10px}a[c]{top:145;left:150;width:100;height:10;border-radius:5px}a[d]{bottom:50;left:175;width:50;height:50;border-radius:10px 10px 0 0}</style>',
}
